import axios from "axios";
import store from "../../redux/store";
import AppConsts from "../../appconst";
import * as actions from "./SettingsTypes";
import { UserLogout } from "../Login/LoginActions";
import { Modal } from "antd";
import { handleAxiosGet, handleAxiosPost } from "../axiosHelper";

var logout = false;

export const saveUser = async (data) => {
  try {
    var result = await axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/api/CreateOrUpdateUser",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (err.response.status == 400) {
        }
        return { result: false, message: error.message };
      });
    return result;
  } catch (err) {
    return { result: false, message: err.message };
  }
};

export const getUserRoleList = async (paramValues) => {
  const endPoint = "/api/GetUserRoleList";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETROLELIST,
      payload: { list: responseData },
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const getUserById = async (paramValues) => {
  const endPoint = "/api/GetUserById";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETUSERBYID,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLocationCode = async (paramValues) => {
  const endPoint = "/api/GetLocationCodes";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLOCATIONCODE,
      payload: responseData.Data,
    });
    return responseData.Data;
  } else {
    return responseData.Data;
  }
};

export const getPolicyList = async (paramValues) => {
  const endPoint = "/api/GetUserPolicyList";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETPOLICYLIST,
      payload: { list: responseData },
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const getManagerList = async (paramValues) => {
  const endPoint = "/api/GetManagerList";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETMANAGERLIST,
      payload: { list: responseData },
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const getDepartmentList = async (paramValues) => {
  const endPoint = "/api/GetDepartmentList";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETDEPARTMENTLIST,
      payload: { list: responseData },
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const getUserList = async (paramValues) => {
  const endPoint = "/api/UserList";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETUSERLIST,
      payload: responseData,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetSettingsFlexiStatus = async (paramValues) => {
  const endPoint = "/api/GetSettingsFlexiStatus";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETSETTINGSFLEXISTATUS,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const GetSettingsEnquiryStatus = async (paramValues) => {
  const endPoint = "/api/GetSettingsEnquiryStatus";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETSETTINGSENQUIRYSTATUS,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const GetSettingsLeadStatus = async (paramValues) => {
  const endPoint = "/api/GetSettingsLeadStatus";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETSETTINGSLEADSTATUS,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLeadsSourceList = async (paramValues) => {
  const endPoint = "/api/GetLeadsSource";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLEADSSOURCELIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLeadsQualificationList = async (paramValues) => {
  const endPoint = "/api/GetLeadsQualification";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLEADSQUALIFICATIONLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLeadsList = async (paramValues) => {
  const endPoint = "/api/Getleadtype";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLEADSLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getDepartmentDDList = async (paramValues) => {
  const endPoint = "/api/Getuserrole";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETDEPARTMENTDDLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLocationList = async (paramValues) => {
  const endPoint = "/api/Getlocation";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLOCATIONLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLocationDefaultList = async (paramValues) => {
  const endPoint = "/api/Getlocationdefaults";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLOCATIONDEFAULTLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLeadsIndustryList = async (paramValues) => {
  const endPoint = "/api/GetLeadsIndustry";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLEADSINDUSTRYLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getLeadsBrandList = async (paramValues) => {
  const endPoint = "/api/GetLeadsBrand";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETLEADSBRANDLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const getRoleAuthorizationList = async (paramValues) => {
  const endPoint = "/api/GetAuthorizationList";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETROLEAUTHORIZATIONLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const GetCategory = async (paramValues) => {
  const endPoint = "/api/GetCategory";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETPROCATEGORY,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetProductCategory1 = async (paramValues) => {
  const endPoint = "/api/GetProductCategory1";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETPROCATEGORY1,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetProductCategory = async (paramValues) => {
  const endPoint = "/api/GetProductCategory";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETPROCATEGORY2,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetEnquirySubCategory = async (CategoryId) => {
  const endPoint = `/api/GetSubCategoriesByCategory/${CategoryId}`;

  try {
    const { data: responseData } = await handleAxiosGet(endPoint);

    if (responseData) {
      store.dispatch({
        type: actions.SETENQUIRYSUBCATEGORY,
        payload: responseData.Data,
      });
      return responseData.Data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    return [];
  }
};

export const GetEnquiryType = async (paramValues) => {
  const endPoint = "/api/GetEnquiryType";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETENQUIRYTYPE,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetEnquiryPriorityList = async (paramValues) => {
  const endPoint = "/api/Getenqpriority";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETENQUIRYPRIORITYLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetEnquiryPaymentsList = async (paramValues) => {
  const endPoint = "/api/Getenqpayments";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETENQUIRYPAYMENTSLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetEnquiryPackstyleList = async (paramValues) => {
  const endPoint = "/api/Getenqpackstyle";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETENQUIRYPACKINGSTYLELIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetEnquiryFacstatusList = async (paramValues) => {
  const endPoint = "/api/Getfacenqstatus";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETENQUIRYFACSTATUSLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetEnquiryDispatchtypeList = async (paramValues) => {
  const endPoint = "/api/Getenqdispatchtype";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETENQUIRYDISPATCHTYPELIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetProductCatList = async (paramValues) => {
  const endPoint = "/api/Getprodcateg";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETPRODUCTCATLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetComplaintCategory = async (paramValues) => {
  const endPoint = "/api/Getcomplaintcateg";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETCOMPLAINTCATLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetComplaintSolution = async (paramValues) => {
  const endPoint = "/api/GetCustSolution";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETCOMPLAINTSOLUTION,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetComplaintType = async (paramValues) => {
  const endPoint = "/api/Getcusttype";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETCOMPLAINTTYPELIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetComplaintStatus = async (paramValues) => {
  const endPoint = "/api/Getcuststatus";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETCOMPLAINTSTATUSLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const GetModeofTransport = async (paramValues) => {
  const endPoint = "/api/Getcusttransp";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETMODEOFTRANSLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const SaveFlexiStatus = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateFlexiStatus`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const SaveEnquiryStatus = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateEnquiryStatus`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const SaveLeadStatus = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLeadStatus`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveSource = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLeadsSource`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveLeadList = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLeadType`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveDepartmentList = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateUserRole`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveLocationList = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLocation`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveLocationDefaultList = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLocationDefaults`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteFlexiStatus = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeleteFlexiStatus/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteEnquiryStatus = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeleteEnquiryStatus/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteLeadStatus = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeleteLeadStatus/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteSource = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeleteLeadsSource/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteLeadList = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deleteleadtype/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

// Task Type Actions
export const getTaskTypeList = async (paramValues) => {
  const endPoint = "/api/GetTaskType";
  const params = paramValues;
  const { data: responseData } = await handleAxiosGet(endPoint, params);

  if (responseData) {
    store.dispatch({
      type: actions.SETTASKTYPELIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData.Data;
  }
};

export const saveTaskType = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateTaskType`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteTaskType = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeleteTaskType/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteDepartmentDDList = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deleteuserrole/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteLocationList = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deletelocation/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteLocationDefaultList = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deletelocationdefaults/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteUser = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeleteUser/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveBrand = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLeadsBrand`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveQualification = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLeadsQualification`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteQualification = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetLeadsQualification/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveIndustry = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateLeadsIndustry`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteIndustry = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetLeadsIndustry/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveCategory = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateProCategory`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteBrand = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetLeadsBrand/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const DeletetProCategory1 = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetProCategory1/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteProSubCategory1 = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetProSubCategory1/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetProCategory/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      Success: false,
      Message: err.response?.data?.Message || err.message,
    };
  }
};

export const AddOrUpdateProCategory1 = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateProCategory1`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const AddOrUpdateProCategory = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateProductCategory`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const DeletetProCategory2 = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetProCategory2/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveEnqType = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateEnquiryType`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveEnqPriority = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateEnqpriority`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveEnqPayments = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateEnqpayments`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveEnqPackstyle = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateEnqPackstyle`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveEnqDispatchType = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateEnqDispatchType`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveEnqFacStatus = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateFacEnqStatus`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveProductCategory = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateProdCateg`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveComplaintCategory = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateComplaintCateg`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveComplaintSolution = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateCustSolution`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveComplaintType = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateCustType`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveComplaintStatus = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateCustStatus`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveModeofTransport = async (data) => {
  try {
    const response = await axios.post(
      `${AppConsts.apiBaseUrl}/api/AddOrUpdateCustTransp`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteEnqType = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/DeletetEnquiryType/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteEnqPriority = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deleteenqpriority/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteEnqPyaments = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deleteenqpayments/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteEnqPackStyle = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deleteenqpackstyle/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteEnqDispatchType = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deleteenqdispatchtype/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteEnqFacStatus = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deletefacenqstatus/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteProductCategory = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deleteprodcateg/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteComplaintCategory = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deletecomplaintcateg/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteComplaintSolution = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/CustSolution/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteComplaintType = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deletecusttype/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteComplaintStatus = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deletecuststatus/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const deleteModeofTransport = async (code) => {
  try {
    const response = await axios.delete(
      `${AppConsts.apiBaseUrl}/api/Deletecusttransp/${code}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    return {
      result: false,
      message: err.response?.data?.message || err.message,
    };
  }
};

export const saveTermsAndConditions = async (data) => {
  try {
    var result = await axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/api/CreateOrUpdateTermsAndConditions",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (err.response.status == 400) {
        }
        return { result: false, message: error.message };
      });
    return result;
  } catch (err) {
    return { result: false, message: err.message };
  }
};

export const GetTermsAndConditions = async (paramValues) => {
  const endPoint = "/api/GetTermsAndConditions";
  const params = paramValues;

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETTERMSANDCONDITIONS,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const saveUserFcmToken = async (payload) => {
  const url = "/api/SaveUserFcmToken";
  const contentType = "application/json";
  const data = payload;

  const { data: responseData } = await handleAxiosPost(url, contentType, data);

  if (responseData.result) {
    return responseData;
  } else {
    return responseData;
  }
};

export const getStageList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/getStageList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETSTAGELIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveStage = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/saveStage",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteStage = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/deleteStage",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getVerticalList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/getVerticalList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETVERTICALLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveVertical = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/saveVertical",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteVertical = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/deleteVertical",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getStatusList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/getStatusList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETSTATUSLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/saveStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/deleteStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getTaskStatusList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetTaskStatusList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETTASKSTATUSLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveTaskStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveTaskStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteTaskStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteTaskStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};
//   try {
//     axios({
//       method: "get",
//       url: AppConsts.apiBaseUrl + "/Settings/GetUserRoleList",
//       params: data,
//       headers: {
//         Authorization: "Bearer " + localStorage.getItem("token"),
//         "Content-Type": "application/json",
//       },
//     })
//       .then((response) => {
//         console.log("response", response);

//         store.dispatch({
//           type: actions.SETUSERROLESLIST,
//           payload: { list: response.data },
//         });
//       })
//       .catch((err) => {
//         if (err?.response?.status == 401) {
//           if (!logout) {
//             logout = true;
//             Modal.confirm({
//               content: "Session expired, Please relogin.",
//               cancelButtonProps: { hidden: true },
//               onOk: () => {
//                 UserLogout();
//               },
//             });
//           }
//         }
//         console.log({ content: err.message });
//       });
//   } catch (err) {
//     console.log({ content: err.message });
//   }
// };

export const saveRoleAuthorization = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/api/SaveRoleAuthorization",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
        }
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    return { result: false, message: err.message };
  }
};

export const copyRoleAuthorization = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/CopyRoleAuthorization",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const saveRole = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveRole",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const assignRole = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/AssignRole",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getAuthorizedPages = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/api/GetAuthorizedPages",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETAUTHORIZEDPAGES,
          payload: { list: response.data.Data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const getAdvanceSeriesList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetAdvanceSeriesList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETADVANCESERIESLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const getAdvanceSetting = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetAdvanceSetting",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETADVANCESETTING,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveAdvanceSetting = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveAdvanceSetting",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getAccountList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetAccountList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETACCOUNTLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

// Support Desk
// project
export const getProjectTypeList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetProjectTypeList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETPROJECTTYPELIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveProjectType = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveProjectType",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteProjectType = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteProjectType",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getProjectStatusList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetProjectStatusList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETPROJECTSTATUSLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveProjectStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveProjectStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteProjectStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteProjectStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const fetchEmbedToken = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: "https://api.powerbi.com/v1.0/myorg/GenerateToken",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

//SupportDesk
// Ticket
export const getTicketLevelList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetTicketLevelList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETTICKETLEVELLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveTicketLevel = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveTicketLevel",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteTicketLevel = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketLevel",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getTicketPriorityList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetTicketPriorityList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETTICKETPRIORITYLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveTicketPriority = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveTicketPriority",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteTicketPriority = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketPriority",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getTicketStatusList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetTicketStatusList",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETTICKETSTATUSLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const saveTicketStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveTicketStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteTicketStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const saveDepartment = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/SaveDepartment",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getDeparmentForEdit = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetDepartmentForEdit",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETDEPARTMENTDETAIL,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const deleteDepartment = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteDepartment",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const deleteIssueType = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/DeleteIssueType",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getNotificationList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetTktNotify",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETNOTIFICATIONLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const updateNotification = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/UpdateTktNotify",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const getHistoryList = async (data) => {
  try {
    axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Settings/GetTktHistory",
      params: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        store.dispatch({
          type: actions.SETHISTORYLIST,
          payload: { list: response.data },
        });
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
      });
  } catch (err) {
    console.log({ content: err.message });
  }
};

export const updateHistory = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/Settings/UpdateTktHistory",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};


export const getNotifyConfigList = async (params) => {
  try {
    const { data: responseData } = await handleAxiosGet("/api/NotifyConfigList", params);
    if (responseData) {
      store.dispatch({
        type: actions.SETNOTIFYCONFIGLIST,
        payload: { list: responseData },
      });
      return responseData;
    } else {
      return responseData;
    }
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const updateNotifyConfig = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/api/UpdateNotifyConfig",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const resetPassword = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/api/resetpassword",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};

export const setUserStatus = async (data) => {
  try {
    var result = axios({
      method: "post",
      url: AppConsts.apiBaseUrl + "/api/SetUserStatus",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return { result: false, message: err.message };
  }
};